import Overview from "./Overview/Overview";
import SelectPackage from "./SelectPackage";
import SelectProject from "./SelectProject";
import SoftwareInfo from "./SoftwareInfo";

export default {
  Overview,
  SelectPackage,
  SelectProject,
  SoftwareInfo,
};
